import { createSelector } from "reselect/lib/index"
import { initialState } from "./reducer"

/**
 * Direct selector to the reportExport state domain
 */

const selectReportExportDomain = (state) =>
  state.get("reportExport", initialState)

/**
 * Other specific selectors
 */

/**
 * Default selector used by ReportExport
 */

export const makeSelectReportExport = () =>
  createSelector(selectReportExportDomain, (state) =>
    state.get("meditions_export")
  )

export const makeSelectDivisionAmbassador = () =>
  createSelector(selectReportExportDomain, (state) =>
    state.get("divisions_ambassador")
  )
// loadingDivisionsAmbassador}

export const makeSelectLoadingMeditionsReportExport = () =>
  createSelector(selectReportExportDomain, (state) =>
    state.get("loadingMeditionsExport")
  )

export const makeSelectConfiguration = () =>
  createSelector(selectReportExportDomain, (state) =>
    state.get("configuration")
  )

export const makeSelectLoadingDivisionsReportExport = () =>
  createSelector(selectReportExportDomain, (state) =>
    state.get("loadingDivisionsAmbassador")
  )

export default makeSelectReportExport
export { selectReportExportDomain }
